import React, { useContext } from 'react';
import cls from './MainInfo.module.css';
import { Input } from '../../../../../components/newUI/Input/Input';
import { useMainInfo } from './useMainInfo';
import { MeasuremntsContext } from '../../../Context/MeasuremntsContext';
import { RowTitle } from '../../../../../Measurements/MeasurementsModal/MeasurementsModalBody/RowTitle';
import { useTranslation } from 'react-i18next';

export const MainInfo = () => {
    const { onInput, calculations } = useMainInfo();
    const { t } = useTranslation();
    const { errorsInput } = useContext(MeasuremntsContext);
    return (
        <div className={cls.container}>
            <Input
                label={t('MainInfo.return.Input.label.inputName.name')}
                inputName="name"
                type="text"
                required
                error={errorsInput.name}
                placeholder={t('MainInfo.return.Input.placeholder.inputName.name')}
                classes={cls.MeasurementInputName}
                value={calculations.name}
                onChange={onInput}
            />
            <div className={cls.rowContainer}>
                <RowTitle
                    title={t('MainInfo.return.RowTitle.title')}
                    details={t('MainInfo.return.RowTitle.details')}
                    type={'autoInput'}
                />
                <div className={cls.MeasurementRow}>
                    <Input
                        label={t('MainInfo.return.Input.label.inputName.length')}
                        inputName="length"
                        type="measurements"
                        placeholder="0"
                        classes={cls.MeasurementInputValue}
                        value={calculations.length}
                        onChange={onInput}
                    />
                    <Input
                        label={t('MainInfo.return.Input.label.inputName.width')}
                        inputName="width"
                        type="measurements"
                        placeholder="0"
                        classes={cls.MeasurementInputValue}
                        value={calculations.width}
                        onChange={onInput}
                    />
                    <Input
                        label={t('MainInfo.return.Input.label.inputName.height')}
                        inputName="height"
                        type="measurements"
                        placeholder="0"
                        classes={cls.MeasurementInputValue}
                        value={calculations.height}
                        onChange={onInput}
                    />
                </div>
            </div>
        </div>
    );
};
